import styled from 'styled-components';
import theme from '../../theme';

export const Button = styled.a`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 7px;
  margin: 0px 5px;
  cursor: pointer;
  background: ${theme.colors.blackOpacity};
  // & > svg > path:hover {
  //   fill: ${theme.colors.red};
  // } 
`;